import React from 'react';
import TicketForm from './TicketForm.js';

export default function AddTicket() {
  return <TicketForm />;
}
